exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".actions {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: end;\n      justify-content: flex-end; }\n  .actions button {\n    width: 100%;\n    margin: 0; }\n\n.green {\n  color: #266900 !important; }\n\n.zero {\n  color: #565656 !important; }\n\n.busy {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center; }\n\n.spinner-inline {\n  min-height: 12px;\n  min-width: 12px;\n  height: 12px;\n  width: 12px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/daily-recon/shifts-recon/components/shift-item/shift-item.component.scss
// module id = ../../../../../src/app/views/daily-recon/shifts-recon/components/shift-item/shift-item.component.scss
// module chunks = main